function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'underscore';
import { constantsRegistry } from '../../constants/tableConstantsFactory';
/**
 * There are two batches of reducers here.  The first operates on the local _only_
 * 'selected' list which reflects the items currently selected in an entity list.
 * The second is the 'selection' list which represents the entity data for the 'selected'
 * list which is returned after a server query.
 */
const indexSuccess = (state, action) => {
  /* the server has more entities, it returns an extra
   entity on the end of the data.
   */
  const {
    data
  } = action.data;
  const newSelected = [];

  /* If there are selections, filter out ones that are
   no longer in the data set that's showing */
  if (state.selected && state.selected.length) {
    const newShownDataByID = _.pluck(data, 'id') || [];
    _.map(state.selected, next => {
      if (_.contains(newShownDataByID, next)) {
        newSelected.push(next);
      }
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    selected: newSelected
  });
};

// Redefine selection to include the passed in In
const select = (state, action) => {
  let selected = _.clone(state.selected);
  selected.push(action.id);
  selected = _.uniq(selected);
  return _objectSpread(_objectSpread({}, state), {}, {
    selected
  });
};

// Add all listed items to selected
const selectAll = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  selected: action.selected || []
});

// Clear the selected values
const selectAllClear = state => _objectSpread(_objectSpread({}, state), {}, {
  selected: []
});

// Redefine selection to include all but the passed in ID
const selectClear = (state, action) => {
  const selected = _.filter(state.selected, selection => selection !== action.id);
  return _objectSpread(_objectSpread({}, state), {}, {
    selected
  });
};
const selectIndex = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  selectLoading: action.loading
});
const selectIndexClear = state => _objectSpread(_objectSpread({}, state), {}, {
  selections: [],
  selectError: null,
  selectLoading: false
});
const selectIndexFailure = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  selections: [],
  selectError: action.error,
  selectLoading: false
});
const selectIndexSuccess = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  selections: action.data,
  selectError: null,
  selectLoading: false
});
export default function selectReducerFactory(entity) {
  const constants = constantsRegistry(entity);

  // note that the returned object is intended for composition and client code will need to call
  // `applyReducers(reducers, state)` to get an expected redux reducer
  return {
    reducers: {
      [constants.INDEX_SUCCESS]: indexSuccess,
      [constants.SELECT]: select,
      [constants.SELECT_ALL]: selectAll,
      [constants.SELECT_CLEAR]: selectClear,
      [constants.SELECT_CLEAR_ALL]: selectAllClear,
      [constants.SELECT_INDEX]: selectIndex,
      [constants.SELECT_INDEX_SUCCESS]: selectIndexSuccess,
      [constants.SELECT_INDEX_FAILURE]: selectIndexFailure,
      [constants.SELECT_INDEX_CLEAR]: selectIndexClear
    },
    initState: {
      selections: [],
      selected: []
    }
  };
}